import React from "react";
import { SvgProps } from "./Form";

export const AttachmentIcon = (props: SvgProps) => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g clip-path="url(#clip0_6799_1071)">
      <path
        d="M7.29163 12.2648C6.81809 12.7257 6.18214 12.9816 5.52136 12.9772C4.86058 12.9728 4.22811 12.7084 3.76079 12.2412C3.29347 11.774 3.02888 11.1416 3.02426 10.4808C3.01965 9.82004 3.27538 9.18401 3.73613 8.71034L5.86713 6.57785L5.15963 5.87085L3.02913 8.00335C2.37027 8.66254 2.00025 9.55647 2.00049 10.4885C2.00072 11.4205 2.37119 12.3142 3.03038 12.9731C3.68958 13.6319 4.58351 14.002 5.51552 14.0017C6.44753 14.0015 7.34127 13.631 8.00013 12.9718L10.1311 10.8408L9.42413 10.1338L7.29163 12.2648Z"
        fill="currentColor"
      />
      <path
        d="M12.9719 3.0307C12.6465 2.7031 12.2594 2.44333 11.8329 2.26644C11.4064 2.08955 10.9491 1.99905 10.4874 2.0002V2.0002C10.0259 1.99897 9.56878 2.08923 9.14241 2.26577C8.71604 2.44231 8.3289 2.70161 8.00337 3.0287L5.86987 5.1602L6.57687 5.8677L8.70937 3.7367C8.94215 3.50252 9.21907 3.31685 9.52409 3.19042C9.82912 3.064 10.1562 2.99935 10.4864 3.0002V3.0002C10.9835 3.00036 11.4694 3.14791 11.8827 3.4242C12.296 3.70048 12.6181 4.09309 12.8083 4.55241C12.9985 5.01172 13.0482 5.51711 12.9512 6.00468C12.8542 6.49226 12.6149 6.94014 12.2634 7.2917L10.1324 9.4227L10.8399 10.1302L12.9709 8.0002C13.6289 7.34074 13.9985 6.44725 13.9987 5.51565C13.9989 4.58406 13.6296 3.69041 12.9719 3.0307V3.0307Z"
        fill="currentColor"
      />
      <path
        d="M9.42276 5.87094L5.87061 9.4231L6.57771 10.1302L10.1299 6.57805L9.42276 5.87094Z"
        fill="currentColor"
      />
    </g>
    <defs>
      <clipPath id="clip0_6799_1071">
        <rect width="12" height="12" fill="white" transform="translate(2 2)" />
      </clipPath>
    </defs>
  </svg>
);
